import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { TaskDtoKeysEnum } from '@zaoblako/shared/modules/task/enum/task-dto-keys.enum';
import { TaskOrder1cStatusEnum } from '@zaoblako/shared/modules/task/enum/task.order.1c.status.enum';
import { DocumentDtoKeysEnum } from '@zaoblako/shared/modules/document/enums/document-dto-keys.enum';
import type { TaskFindInterface } from '@zaoblako/shared/modules/task/dtos/task/task-find.dto';
import type { DocumentFindInterface } from '@zaoblako/shared/modules/document/dtos/document/document-find.dto';

import * as yup from 'yup';

export interface TaskOrderFindInterface {
  /** Unique identifier. Cannot be changed */
  id: number;
  /** Order creation date and time */
  created: Date;
  /** Order last update date and time */
  updated: Date;
  /** Payment amount in roubles */
  amount: number;
  /** Task order subject */
  subject: string;
  /** Payment date */
  date: Date;
  /** Document code in 1C ERP database */
  document: string;
  /** Deletion mark from 1C ERP database */
  deleted: boolean;
  /** Payment order status in 1C ERP database */
  status: TaskOrder1cStatusEnum;
  /** Related task */
  task: TaskFindInterface;
  /** Related documents */
  documents?: DocumentFindInterface[];
  /** TBank document string (possibly uuid, but it's not certain) */
  tbankDocumentId?: string;
  /** Идентификатор запроса платежа Точка.API */
  tochkabankDocumentId?: string;
}

export const TaskOrderFindDto = SerdeDtoClass.create<TaskOrderFindInterface>(TaskDtoKeysEnum.TASK_ORDER_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  created: {
    label: 'Создано',
    serializer: yup.date(),
  },
  updated: {
    label: 'Обновлено',
    serializer: yup.date(),
  },
  amount: {
    label: 'Сумма платежа',
    serializer: yup.number(),
  },
  subject: {
    label: 'Назначение платежа',
    serializer: yup.string(),
  },
  date: {
    label: 'Дата платежа',
    serializer: yup.date(),
  },
  document: {
    label: 'Номер платежа в 1С',
    hint: 'Задан только для платежных поручений, выгруженных в 1С',
    serializer: yup.string(),
  },
  deleted: {
    label: 'Удалён',
    serializer: yup.boolean(),
  },
  status: {
    label: 'Статус в 1С',
    hint: 'Задан только для платежных поручений, выгруженных в 1С',
    serializer: yup
      .string()
      .oneOf(Object.values(TaskOrder1cStatusEnum)),
  },
  task: {
    optional: true,
    label: 'Заявка на платеж',
    nested: TaskDtoKeysEnum.TASK_FIND_DTO,
    serializer: (_, nested) => nested,
  },
  documents: {
    optional: true,
    label: 'Документы',
    nested: DocumentDtoKeysEnum.DOCUMENT_FIND_DTO,
    serializer: (_, nested) => yup.array(nested),
  },
  tbankDocumentId: {
    optional: true,
    label: 'ID платежного документа в TBank',
    serializer: yup.string(),
  },
  tochkabankDocumentId: {
    optional: true,
    label: 'ID платежного документа в Точка Банке',
    serializer: yup.string(),
  },
});
